import React from "react";

export default function PageHeader({ headingText }: { headingText: string }) {
  return (
    <h5 className="mb-1 text-2xl font-bold text-center text-gray-900 dark:text-white">
      {headingText}
    </h5>
  );
}
